import { render, staticRenderFns } from "./OrderExchangeOrReturn.vue?vue&type=template&id=385beae4&scoped=true"
import script from "./OrderExchangeOrReturn.vue?vue&type=script&lang=js"
export * from "./OrderExchangeOrReturn.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeOrReturn.vue?vue&type=style&index=0&id=385beae4&prod&lang=scss&scoped=true"
import style1 from "./OrderExchangeOrReturn.vue?vue&type=style&index=1&id=385beae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385beae4",
  null
  
)

export default component.exports